import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Velada Chófer',
    shortName: 'Velada',
    tagline: 'Chófer privado',
    description: 'Berlinas, SUV, vans y limusinas con chófer para traslados al aeropuerto, bodas, eventos y viajes de empresa. Elige tu vehículo y solicita tu reserva online.',
    url: getOrigin()
}

export const NAV_LINKS = [
    { label: 'Vehículos', href: '/#vehiculos' },
    { label: 'Cómo reservar', href: '/#reservar' }
] as const

export const SERVICE_TYPES = [
    'Traslado al aeropuerto o estación',
    'Servicio por horas',
    'Boda',
    'Evento o celebración',
    'Viaje de empresa'
] as const

export const BOOKING_STEPS = [
    {
        title: 'Cuéntanos tu trayecto',
        text: 'Fecha, hora, punto de recogida y cuántos vais a viajar.'
    },
    {
        title: 'Te confirmamos disponibilidad',
        text: 'Revisamos tu solicitud y te enviamos el precio final antes de cerrar nada.'
    },
    {
        title: 'Tu chófer te espera',
        text: 'Puntual en el lugar acordado y con el vehículo listo para salir.'
    }
] as const
